import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import BellyPiercingImage from '../../Assets/Piercing Services/belly piercing (2).png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function BellyPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
            <title>Belly Piercing Dubai, UAE </title>
            <meta
                name="description"
                content="Belly Piercing Dubai, UAE for a stylish body piercing with precise placement, quality jewellery and professional piercing service."
            />  
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Belly Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Belly Piercing 200-250 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={BellyPiercingImage} alt="Belly Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Belly Piercing</h3>

          <p>
            Enhance your style with our professional belly piercing services in the UAE, available at an affordable price range of 200–250 AED. Belly piercing, also known as navel piercing, is a sexy and bold choice that adds a unique and eye-catching touch to your overall appearance. Perfect for those who love to express confidence and individuality, a belly button piercing is a popular trend that never goes out of style. Whether you want to complement your beachwear, elevate your fashion statement, or simply try something new, our expert specialists ensure precise placement for a stunning and flattering look.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each belly piercing with accuracy and care. We follow strict hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe experience for every client. Our goal is to provide a smooth, gentle, and pain-minimized procedure, making your belly piercing experience comfortable and stress-free.
          </p>

          <p>
            Belly piercing is ideal for individuals who want to make a bold style statement while maintaining elegance. It offers versatility in jewelry options, from simple and minimal designs to glamorous and decorative pieces that enhance your look. Our specialists take the time to understand your preferences and guide you in choosing the best placement and jewelry style that suits your body shape and personal aesthetic. With expert consultation, we ensure that your piercing not only looks great but also heals properly.
          </p>

          <p>
            The procedure is quick and typically completed within minutes, making it convenient even for those with busy schedules. Our team uses advanced techniques designed to reduce discomfort and promote faster healing, allowing you to enjoy your new piercing with confidence. We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and allergic reactions during the healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that you feel relaxed from the moment you walk in. We understand that getting a body piercing can feel intimidating, especially for first-timers, and our friendly staff is always available to guide you and answer any questions. We focus on delivering a positive and comfortable experience that leaves you feeling confident and satisfied.
          </p>

          <p>
            Aftercare is an essential part of maintaining your belly piercing, and we provide detailed instructions to help you care for it properly. Our team will guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation. Proper aftercare ensures a smooth healing process and helps your piercing remain a long-lasting and stylish addition to your look.
          </p>

          <p>
            Our belly piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden costs. Booking your appointment is simple and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted belly piercing services in the UAE for a safe, stylish, and professional experience. With experienced specialists, hygienic procedures, and a focus on customer satisfaction, we help you achieve a bold and standout look effortlessly. Book your belly piercing appointment today and express your style with confidence and elegance.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Belly Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default BellyPiercing;